import { NodeViewProps, NodeViewWrapper } from "@tiptap/react";
import { useEffect, useState } from "react";

import { useSnippetDialog } from "@/components/Playground2/Messages/SnippetDialog/snippet-store";
import { usePlayground } from "@/components/Playground2/playground-store";
import { useUser } from "@/context/user-context";
import { PromptVersionSnippet } from "@/types";
import { PromptTemplateConfiguration } from "@/types/evaluate";
import SnippetDisplay from "./SnippetDisplay";
import "./styles.css";

const getTemplate = (
  promptName: string,
  sourcedSnippets: Array<PromptVersionSnippet>,
  version?: number,
  label?: string,
) => {
  const snippet = sourcedSnippets.find(
    (snippet) =>
      snippet.prompt_template_name === promptName &&
      (version ? snippet.prompt_version_number === version : true) &&
      (label ? snippet.label === label : true),
  );
  return snippet;
};
const Snippet = (props: NodeViewProps) => {
  const dialog = useSnippetDialog();
  const [configuration, setConfiguration] = useState<
    Partial<PromptTemplateConfiguration>
  >({
    template: {
      name: props.node.attrs.name || "",
      version_number: props.node.attrs.version_number || undefined,
      label: props.node.attrs.label || undefined,
    },
  });

  const activeWorkspaceId = useUser()?.activeWorkspaceId!;

  useEffect(() => {
    if (!props.node.attrs.mounted) {
      // Use setTimeout to defer the state updates to the next tick
      setTimeout(() => {
        props.updateAttributes({ mounted: true });
        dialog.openDialog(configuration, setConfiguration);
      }, 0);
    }
  }, [
    configuration,
    setConfiguration,
    dialog,
    props.node.attrs.mounted,
    props,
  ]);

  useEffect(() => {
    // Use setTimeout to defer the attribute update to the next tick
    setTimeout(() => {
      props.updateAttributes({
        name: configuration?.template?.name,
        version_number: configuration?.template?.version_number,
        label: configuration?.template?.label,
      });
    }, 0);
  }, [configuration, props]);

  try {
    const playground = usePlayground();
    const sourcedSnippets = playground.sourcedSnippets;
    if (!props.editor.isEditable) {
      const linked_template =
        sourcedSnippets &&
        getTemplate(
          props.node.attrs.name,
          sourcedSnippets,
          Number(props.node.attrs.version_number),
          props.node.attrs.label,
        );

      const uri = `/workspace/${activeWorkspaceId}/prompt/${linked_template?.prompt_registry_id}/version/${linked_template?.prompt_version_number}`;

      return (
        <SnippetDisplay
          promptName={props.node.attrs.name}
          version={props.node.attrs.version_number}
          label={props.node.attrs.label}
          isReadOnly={true}
          href={uri}
        />
      );
    }
  } catch (e) {}

  return (
    <NodeViewWrapper className="inline-flex">
      <SnippetDisplay
        promptName={props.node.attrs.name}
        onClick={() => {
          dialog.openDialog(
            {
              template: {
                name: props.node.attrs.name,
                version_number: props.node.attrs.version_number,
                label: props.node.attrs.label,
              },
            },
            (value) => {
              setConfiguration(value);
            },
          );
        }}
        version={props.node.attrs.version_number}
        label={props.node.attrs.label}
      />
    </NodeViewWrapper>
  );
};

export default Snippet;
